import { DialogTitle as StyledDialogTitle } from './DialogTitle.styled';
import { Props } from './types';

export const DialogTitle = ({ ...props }: Props) => <StyledDialogTitle {...props} />;

export default DialogTitle;
